import { Component } from '@angular/core'
import { EnvService } from '@envs/env-service'
import { environment } from '@envs/environment'
import { AuthService } from '@core/service/auth.service'

@Component({ selector: 'profile', templateUrl: './profile.component.html', styleUrls: ['./profile.component.scss'] })
export class ProfileComponent {
  constructor(
    private envService: EnvService,
    private authService: AuthService
  ) {}

  public get baseJsUrl(): string {
    return `${this.envService.baseJsUrl}/profile?host=${environment.baseHost}&childCompany=${this.authService.loggedInUser?.company.id}`
  }
}
